/**
 * Created by vladislav on 13.02.2020
 */
const ShortMetaProgressView = cc.Node.extend({
    ctor: function () {
        this._super();
        this.setAnchorPoint(0.5, 0.5);

        this.createLevels();

        this.onResize();
    },

    onEnter: function () {
        this._super();
        this.onResize();
    },

    onResize: function () {
        const sceneSize = cleverapps.resolution.getSceneSize();
        const scale = 2 - Math.min(sceneSize.width / sceneSize.height, 1);

        this.levelsView.children.forEach((levelView) => {
            levelView.baseScaleX = levelView.baseScaleY = scale;
            levelView.setScale(scale);
        });
        cleverapps.UI.wrap(this.levelsView);
        this.setContentSize2(this.levelsView.getContentSize());
        this.parent && this.updateScale();

        const styles = cleverapps.styles.ShortMetaProgressView;
        this.levelsView.setAlignment(this.width / 2, this.height / 2);
        this.levelsView.children.forEach((levelView, index) => {
            const x = index * (levelView.width + styles.margin.x);
            let marginY = styles.margin.y;
            if (cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL) {
                marginY = styles.margin.mobileY;
            }
            const y = (index % 2 ? -1 : 1) * marginY;

            levelView.setAlignment(x, y);
        });
    },

    hide: function () {
        this.setCascadeOpacityEnabledRecursively(true);
        this.runAction(new cc.FadeOut(0.15));
    },

    updateScale: function () {
        const styles = cleverapps.styles.ShortMetaProgressView;

        const sceneWidth = cleverapps.resolution.getSceneSize().width;

        let scale = 1 / this.parent.scale;
        const width = this.width + styles.paddingX;
        if (width > sceneWidth) {
            scale = scale * sceneWidth / width;
        }
        this.setScale(scale);
    },

    createLevels: function () {
        const location = cleverapps.meta.getSelectedLocation();
        const levels = [];

        for (let progress = 0; progress < ShortMetaLocation.LEVELS_PER_LOCATION; progress++) {
            levels.push(new ShortMetaLevel(location, progress));
        }

        const levelsView = this.levelsView = new cc.Node();
        levelsView.setAnchorPoint(0.5, 0.5);
        levels.forEach((level) => {
            const view = new LevelView(level);
            levelsView.addChild(view);
        });
        this.addChild(levelsView);
    }
});

cleverapps.styles.ShortMetaProgressView = {
    paddingX: 200,

    margin: {
        x: 10,
        y: 0,
        mobileY: 0
    },

    position: {
        x: { align: "center", dx: 0 },
        y: { align: "bottom", dy: 400 }
    }
};